export function base64ToBlob(value, contentType = '') {
  if (typeof value !== 'string' || !value.trim()) return null;

  try {
    const normalized = value.replace(/^data:[^;]+;base64,/, '').replace(/\s/g, '');
    const decoded = atob(normalized);
    if (!decoded.length) return null;
    const bytes = Uint8Array.from(decoded, (character) => character.charCodeAt(0));
    return new Blob([bytes], { type: contentType });
  } catch {
    return null;
  }
}
